import Select from 'react-select';
import { customStyles } from '../data/MochaData';

const DropDown = ({
    field = '',
    label = '',
    valueSelect = '',
    dataProvider = [],
    onChangeSelect = () => { },
    isRequired = true,
    hasDescription = false,
    id = ''

}: IPropsDropdown) => {

    const ChangeDropDown = (newValue: any, actionMeta: any) => onChangeSelect(actionMeta.name, newValue.value);

    return (
        <>
            <div className="lbl-input-re-ni mt-10 mb-5">
                <span> {label} </span>
            </div>
            <Select
                id={id}
                className='w100 mb-20'
                name={field}
                options={dataProvider}
                getOptionLabel={(x: any) => hasDescription ? `${x.text} - ${x.text2}` : x.text}
                getOptionValue={(x: any) => x.value}
                value={dataProvider.find((x: any) => x.value === valueSelect) != null ? dataProvider.find((x: any) => x.value === valueSelect) : null}
                placeholder='Seleccionar'
                onChange={ChangeDropDown}
                styles={customStyles}
            />
            <input
                className="input-required"
                value={valueSelect}
                tabIndex={-1}
                autoComplete="off"
                style={{ opacity: 0, height: 0 }}
                required={isRequired}
            />

        </>
    );
}

export { DropDown };